import './App.css';
import { useState, useEffect } from 'react';

import franceFlag from './image/flag/france.svg'
import switzerlandFlag from './image/flag/Switzerland.svg'
import thailandFlag from './image/flag/thailand.svg'
import romaniaFlag from './image/flag/romania.svg'

function App() {
  const [currentImage, setCurrentImage] = useState(0);

  const heroImages = [
    {
      url: require('./image/pictures/analyse-ruche.jpg'),
      alt: 'Récolte de miel en Casamance'
    },
    {
      url: require('./image/pictures/apiculteur-ruche.jpg'),
      alt: 'Ruches traditionnelles'
    },
    {
      url: require('./image/pictures/miel.jpg'),
      alt: 'Production de miel'
    },
    {
      url: require('./image/pictures/presentation.jpg'),
      alt: 'Production de miel'
    }
  ];

  const testimonials = [
    {
      name: "France",
      role: "L'Abeille Royale de Compiègne",
      url:"https://www.facebook.com/p/Labeille-royale-de-Compi%C3%A8gne-100035059971440/?locale=fr_FR",
      text: "Perfectionnement des techniques de production de mâles et mise en œuvre de stratégies de lutte contre le varroa, essentiel pour préserver la santé des colonies.",
      image: franceFlag
    },
    {
      name: "Roumanie",
      role: "Alina Varadi",
      url:"https://www.casabio.ro/",
      text: "Approfondissement des bienfaits de l’apithérapie, de l’apilarmie et de l’apinutrition, intégrant les produits de la ruche dans une approche holistique de la santé.",
      image: romaniaFlag
    },
    {
      name: "Suisse",
      role: "Agriculteur local",
      url:'',
      text: "Maîtrise de l’élevage de reines, de la division artificielle des colonies et des techniques en stations de fécondation pour améliorer la génétique apicole.",
      image: switzerlandFlag
    },
    {
      name: "Thailande",
      role: "Agriculteur local",
      url:'',
      text: "Découverte des pratiques ancestrales de l’apithérapie et de l’acupuncture au venin d’abeille, combinées à l’observation des ruches locales.",
      image: thailandFlag
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % heroImages.length);
    }, 5000); // Change image every 4 seconds

    return () => clearInterval(timer);
  }, []);

  const partners = [
    {
      description:`Mamadou LY, apiculteur : "L'utilisation des engrais chimiques pour l'agriculture dans la zone fait fuir les abeilles"
Dans cet entretien, Mamadou Ly discute des défis auxquels est confrontée la filière apicole au Sénégal, notamment l'impact des engrais chimiques sur les populations d'abeilles, et souligne l'importance de la formation et du soutien aux apiculteurs locaux.`,
      logo: require('./image/testimonial/allforsciences.png'),
      link: 'https://allforsciences.media/mamadou-ly-apiculteur-lutilisation-des-engrais-chimiques-pour-lagriculture-dans-la-zone-fait-fuir-les-abeilles/'
    },
    {
      description:'',
      logo: require('./image/testimonial/canal+afrique.png'),
      link: 'https://www.canalplus.com/'
    },
    {
      description:`Mamadou, l’apiculteur écolo et solidaire du Sénégal
Cet article présente le parcours de Mamadou Ly, apiculteur renommé du village de Niaga, près du lac Rose. Il y partage son engagement en faveur de l'apiculture écologique et solidaire, ainsi que ses efforts pour former de nouveaux apiculteurs à travers l'Afrique.`,
      logo: require('./image/testimonial/mr_mondialisation.png'),
      link: 'https://mrmondialisation.org/mamadou-apiculteur-ecolo-solidaire-senegal/'
    },
    {
      description:`L'athérapie de la cire du miel : Les bienfaits insoupçonnés révélés par Mamadou Ly, apiculteur de formation
Lors d'une conférence publique, Mamadou Ly partage son expertise sur les bienfaits thérapeutiques de la cire d'abeille, mettant en lumière des aspects méconnus de l'apiculture.`,
      logo: require('./image/testimonial/Ledakarois.png'),
      link: 'https://ledakarois.sn/latherapie-de-la-cire-du-miel-les-bienfaits-insoupconnes-reveles-par-mamadou-ly-apiculteur-de-formation/'
    },
    {
      description:`L'invité d'Infos Matin : Mamadou LY, Apiculteur
Dans cette interview vidéo, Mamadou Ly partage son expérience et ses perspectives sur l'apiculture au Sénégal.`,
      logo: require('./image/testimonial/tfm.jpg'),
      link: 'https://youtu.be/5Cqfj7Hj81A?si=ydEu9YY7rHLQ52KB'
    }
  ];


  const features = [
    {
      title: "Production de miel",
      description: "Un miel récolté avec soin pour préserver toute la richesse de la nature",
      icon: "🐝"
    },
    {
      title: "Déménagement d’essaim",
      description: "Un service respectueux pour déplacer les colonies d'abeilles en toute sécurité",
      icon: "🚚"
    },
    {
      title: "Apinutrition",
      description: "Les bienfaits nutritifs de la ruche",
      icon: "🍯"
    },
    {
      title: "Soin naturels actifs et apithérapie",
      description: "Des solutions naturelles issues de la ruche pour votre bien-être",
      icon: "🌿"
    },
    {
      title: "Pollinisation",
      description: "Un soutien essentiel aux cultures grâce au travail des abeilles",
      icon: "🌸"
    },
    {
      title: "Apilarnie",
      description: "Une méthode innovante pour préserver la santé et le bien-être des abeilles",
      icon: "🛡️"
    },
    {
      title: "Vente de matériel apicole",
      description: "Du matériel professionnel pour accompagner les apiculteurs à chaque étape",
      icon: "🛠️"
    },
    {
      title: "Formations en apiculture",
      description: "Apprenez l’art de l’apiculture avec des experts passionnés",
      icon: "📚"
    }
  ];

  const sponsorshipBenefits = [
    {
      icon: "🎁",
      title: "Miel Offert",
      description: "Recevez 1 pot de miel par récolte issu de votre ruche parrainée"
    },

    {
      icon: "🌍",
      title: "Impact Écologique",
      description: "Contribuez à la préservation de la biodiversité"
    },
    {
      icon: "🤝",
      title: "Soutien Local",
      description: "Aidez les apiculteurs du sénégal"
    }
  ];

  return (
    <div className="App">
      <nav className="navbar">
        <div className="container">
        <img className="logo" alt="SENLEM" src={require('./image/logo.png')}></img>
{/*           <div className="logo">SENLEM</div>
            <div className="nav-links">
            <a href="#produits">Produits</a>
            <a href="#about">À propos</a>
            <a href="#contact">Contact</a>
          </div> */}
        </div>
      </nav>

      <section id="hero" className="hero">
        <div className="container">
          <div className="hero-content">
            <h1>Bienvenue sur SENLEM</h1>
            <p>Je suis Mamadou Ly, apiculteur sénégalais passionné avec plus de 20 ans d’expérience. À travers SENLEM, je produis un miel d’exception tout en partageant mon savoir-faire en apiculture tropicale. Découvrez ici ma passion pour les abeilles, mon engagement pour l’environnement et mes produits authentiques.</p>
          </div>
          <div className="hero-image-container">
            {heroImages.map((image, index) => (
              <div
                key={index}
                className={`hero-image ${index === currentImage ? 'active' : ''}`}
              >
                <img
                  src={image.url}
                  alt={image.alt}
                  loading={index === 0 ? 'eager' : 'lazy'}
                />
              </div>
            ))}
            <div className="hero-image-dots">
              {heroImages.map((_, index) => (
                <button
                  key={index}
                  className={`image-dot ${index === currentImage ? 'active' : ''}`}
                  onClick={() => setCurrentImage(index)}
                  aria-label={`Image ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>


      <section id="features" className="features">
        <div className="container">
          <h2>Notre Expertise</h2>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="produits" className="products">
        <div className="container">
          <h2>Nos Produits</h2>
          <div className="products-grid">
            <div className="product-card">
              <img src={require('./image/pictures/honey.jpg')} alt="Miel" />
              <h3>Miel 🍯</h3>
            </div>
            <div className="product-card">
              <img src="/images/honey2.png" alt="Pommade de venin" />
              <h3>Pommade de venin</h3>
            </div>
            <div className="product-card">
              <img src="/images/honey2.png" alt="Propolis" />
              <h3>Propolis</h3>
            </div>
            <div className="product-card">
              <img src="/images/honey2.png" alt="Gelée royale" />
              <h3>Gelée royale</h3>
            </div>
            <div className="product-card">
              <img src="/images/honey2.png" alt="Pollen" />
              <h3>Pollen</h3>
            </div>
            <div className="product-card">
              <img src="/images/honey2.png" alt="Cire" />
              <h3>Cire</h3>
            </div>
          </div>
        </div>
      </section>

      <section className="partners">
        <div className="container">
          <h2>Ils parlent de nous</h2>
          <div className="logo-carousel">
            <div className="logo-track">
              {[...partners, ...partners].map((partner, index) => (
                <div key={index} className="partner-logo">
                  <a href={partner.link} target="_blank" rel="noopener noreferrer">
                    <img src={partner.logo} alt={`Partenaire ${index + 1}`} />
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="testimonials-section">
      <div className="container">
          <h2>Sur les Traces des Abeilles du Monde</h2>
          <div className="testimonials-carousel">
            <div className="testimonials-track">
              {[...testimonials, ...testimonials].map((testimonial, index) => (
                <div key={index} className="testimonial-card">
                  <div className="testimonial-image">
                    <img src={testimonial.image} alt={testimonial.name} />
                  </div>
                  <div className="testimonial-content">
                    <h3 className="testimonial-name">{testimonial.name}</h3>
                    <p className="testimonial-text">"{testimonial.text}"</p>
                    <p className="testimonial-role">{testimonial.role}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          </div>
        </section>

      <section id="sponsorship" className="sponsorship">
        <div className="sponsorship-background"></div>
        <div className="container">
          <div className="sponsorship-content">
            <h2>Parrainez une Ruche</h2>
            <p className="section-subtitle">
              Devenez acteur de la préservation des abeilles au Sénégal
            </p>

            <div className="sponsorship-grid">
              {sponsorshipBenefits.map((benefit, index) => (
                <div key={index} className="benefit-card">
                  <div className="benefit-icon">{benefit.icon}</div>
                  <h3>{benefit.title}</h3>
                  <p>{benefit.description}</p>
                </div>
              ))}
            </div>

            <div className="sponsorship-plans">
              <div className="plan-card featured">
                <div className="plan-header">
                  <h3>Parrainage Annuel</h3>
                  <div className="plan-price">
                    <span className="amount">50 000</span>
                    <span className="currency">FCFA</span>
                  </div>
                </div>
                <ul className="plan-features">
                  <li>✓ 2kg de miel par an</li>
                  <li>✓ Certificat de parrainage</li>
                  <li>✓ Photos trimestrielles</li>
                  <li>✓ Visite de la ruche possible</li>
                </ul>
                <button className="primary-button">Parrainer maintenant</button>
              </div>
            </div>

            <div className="sponsorship-cta">
              <div className="cta-content">
                <h3>Vous êtes une entreprise ?</h3>
                <p>Découvrez nos programmes de parrainage sur mesure pour les entreprises</p>
                <a href='mailto:contact@senlem.org'><button className="secondary-button">Contactez-nous</button></a>
                
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-info">
              <p>SENLEM</p>
              <p>Mamadou Ly</p>
              <p>Niague, Lac Rose, Sénégal</p>
              <p>+221 77 170 12 20</p>
              <p>contact@senlem.org</p>
              <a href="https://wa.me/+221771701220">Whatsapp</a>
            </div>
           {/*  <div className="footer-links">
              <p>Liens Rapides</p>
              <a href="#produits">Produits</a>
              <a href="#about">À propos</a>
              <a href="#contact">Contact</a>
            </div> */}
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
